import { Images } from "lucide-react";

/**
 * What a paid member sees on the Media tab when nothing has been attached yet.
 *
 * An empty panel reads as a broken one. The icon is deliberately washed out so it
 * reads as a placeholder for media rather than as media, and the sentence says
 * what will be here and, for an event still ahead, when.
 */
export default function EventMediaEmptyState({ hasPassed }: { hasPassed: boolean }) {
  return (
    <div
      role="status"
      style={{
        display: "grid",
        justifyItems: "center",
        gap: ".7rem",
        padding: "2.5rem 1.5rem",
        marginTop: "1.5rem",
        textAlign: "center",
        borderRadius: ".9rem",
        border: "1px dashed rgba(255,255,255,.12)",
        background: "rgba(255,255,255,.02)",
      }}
    >
      <Images size={44} strokeWidth={1.4} aria-hidden="true" style={{ color: "#94A3B8", opacity: .35 }} />
      <p style={{ margin: 0, color: "#CBD5E1", fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "var(--chi-body)" }}>
        {hasPassed ? "No media has been added for this event yet" : "Media & resources will appear here after the event"}
      </p>
      <p style={{ margin: 0, maxWidth: "34rem", color: "#94A3B8", fontFamily: "'Inter', sans-serif", fontSize: "var(--chi-body-compact)", lineHeight: 1.55 }}>
        {hasPassed
          ? "The recording, slides and handouts are added by the organisers once they are ready. Check back soon."
          : "The recording, slides and handouts from the session are shared here for members once it has taken place."}
      </p>
    </div>
  );
}
